/**
 * Trip Service - Frontend
 * Handles trip creation, updates, and reviews
 * Integrates with Activity Service for unified activity management
 *
 * Facade over the domain modules in ./trips/ — preserves the legacy
 * `TripService.method()` call surface so the 30+ existing importers don't
 * change. New code can import from the domain modules directly:
 *   - ./trips/tripsCore        — CRUD, lists, copy/merge, visibility, trash
 *   - ./trips/tripReviews      — post-trip review, feedback, accommodation reviews
 *   - ./trips/tripBoards       — trip-owned board, references
 *   - ./trips/tripCollections  — collaborative collections + items
 */

import { transformTripData } from './trips/transform';
import * as tripsCore from './trips/tripsCore';
import * as tripReviews from './trips/tripReviews';
import * as tripBoards from './trips/tripBoards';
import * as tripCollections from './trips/tripCollections';

const TripService = {
  transformTripData,
  ...tripsCore,
  ...tripReviews,
  ...tripBoards,
  ...tripCollections
};

export default TripService;
